import { SelectField } from '@mews-commander/form';
import { createOption, TooltippedIcon } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { IconName } from '@optimus-web/icons';
import { Disableable } from '@optimus-web/common';
import { useIntersectingServicesSuspenseQuery } from '../../queries/intersectingServices';
import { useSelectedEnterpriseIdsContext } from '../../contexts/SelectedEnterpriseIdsContext';

export const ServiceSelectField = ({ disabled }: Disableable) => {
    const { enterpriseIds } = useSelectedEnterpriseIdsContext();
    const { intersectingServices, noIntersectingServices } = useIntersectingServicesSuspenseQuery({
        enterpriseIds,
    });
    return (
        <SelectField
            autoFocus
            options={intersectingServices.map(({ externalIdentifier }) =>
                createOption({ value: externalIdentifier, label: externalIdentifier })
            )}
            name="serviceKey"
            label={lt('ServiceKey')}
            required
            size="medium"
            captionIconWithTooltip={
                <TooltippedIcon
                    size="small"
                    value={IconName.Info}
                    tooltip={lt('RateGroupGeneralDetailsServiceTooltip')}
                />
            }
            disabled={noIntersectingServices || disabled}
        />
    );
};
